export default function(response) {
  let res = response.data
  if (res.status === 2) {
    // 登录超时
    console.info(response.config.url, res)
    window.location.href = localStorage.getItem('t2s')
      ? window.ConfigNew.tlogin
      : window.ConfigNew.login
  } else if (res.status === 2001) {
    // 权限错误
    console.info(response.config.url, res)
    window.location.href = localStorage.getItem('t2s')
      ? window.ConfigNew.tlogin
      : window.ConfigNew.login
  } else if (res.status === 2101 || res.status === 2102) {
    // 非VIP用户查看VIP内容
    console.info(res)
    window.location.href = '/stu'
  } else {
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/axios/response_interceptors/getData.js